import React, { Suspense, useState } from "react";
import styled from "styled-components";
import images from "../../../../../images/Featured Projects/Innocean/images.webp";
import images2 from "../../../../../images/Featured Projects/Innocean/images2.webp";
import images3 from "../../../../../images/Featured Projects/Innocean/images3.webp";
import images4 from "../../../../../images/Featured Projects/Innocean/images4.webp";
import img from "../../../../../images/Featured Projects/Top.webp";
import { Helmet } from "react-helmet-async";

const Navbar = React.lazy(() => import("../Navbar"));
const Sidebar = React.lazy(() => import("../Navbar/Sidebar"));

export const AllProjectContainers = styled.div`
  background: #0f0f0f;
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  height: 100vh;
`;

export const ProjectContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 200px;
  background-image: url(${img});
  padding-top: 4rem;
`;

export const Titles = styled.h1`
  color: #fff;
  padding-top: 3.5rem;
  text-align: center;
`;

export const ProjectText = styled.div`
  max-width: 500px;
  padding-top: 7rem;

  @media (max-width: 575.98px) {
    padding-top: 2rem;
  }
`;

export const SubTitle = styled.h2`
  color: #e85508;
  padding-bottom: 1rem;
  text-align: center;
`;

export const ListDesc = styled.p`
  color: #fff;
  padding-bottom: 0.5rem;
  text-align: center;
  font-size: 16px;
  letter-spacing: 0.03em;
  line-height: 160%;
`;

export const Text = styled.p`
  color: #e2e2e2;
  max-width: 400px;
  padding-bottom: 0.5rem;
  font-size: 16px;
  letter-spacing: 0.03em;
  line-height: 160%;
  text-align: center;

  @media (max-width: 575.98px) {
    max-width: 350px;
    text-align: left;
  }
`;

export const Bolder = styled.p`
  font-weight: 600;
  font-size: 16px;
  letter-spacing: 0.03em;
  line-height: 160%;
  color: #fff;
  padding-top: 0.5rem;
`;

export const ProjectIMG = styled.div`
  padding-top: 1rem;
`;

export const IMG = styled.img`
  height:100%
  fit-content: cover;
  min-width: 330px;

  @media (max-width: 575.98px) {
    max-width: 450px;
    max-height: 250px;
  }
`;

const Innocean = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <Helmet>
        <title>Featured Project | Innocean Office Expansion</title>
        <meta
          name="description"
          content="The featured project of Innocean Office Expansion from PT ICONIQ MULTI DIMENSI - ICONIQ Interior"
        />
        <link
          rel="canonical"
          href="https://iconiq-interior.co.id/project/featured-project/innocean"
        />
      </Helmet>
      <AllProjectContainers>
        <Suspense fallback={<div>Loading...</div>}>
          <Sidebar isOpen={isOpen} toggle={toggle} />
        </Suspense>
        <Suspense fallback={<div>Loading...</div>}>
          <Navbar toggle={toggle} />
        </Suspense>
        <TitleContainer>
          <Titles>Innocean Office Expansion</Titles>
        </TitleContainer>
        <ProjectContainer>
          <ProjectText>
            <SubTitle>Project Details :</SubTitle>
            <ListDesc>
              <Text>
                <Bolder>Project :</Bolder> Innocean Office Expansion
              </Text>
              <Text>
                <Bolder>Business Core :</Bolder> Technology - Based Digital
                Marketing
              </Text>
              <Text>
                <Bolder>Area :</Bolder> 600 sqm
              </Text>
              <Text>
                <Bolder>Location :</Bolder> Treasury Tower, SCBD
              </Text>
              <Text>
                <Bolder>Concept :</Bolder>Minimalist and Industrialist with ABW
                Layout Concept For Flexible Office Space
              </Text>
            </ListDesc>
          </ProjectText>
          <ProjectIMG>
            <IMG
              src={images}
              alt="Iconiq Interior featured project Innocean Office Expansion"
              title="Featured Project | Innocean Office Expansion"
              loading="eager"
            />
          </ProjectIMG>
          <ProjectIMG>
            <IMG
              src={images2}
              alt="Iconiq Interior featured project Innocean Office Expansion"
              title="Featured Project | Innocean Office Expansion"
              loading="lazy"
            />
          </ProjectIMG>
          <ProjectIMG>
            <IMG
              src={images3}
              alt="Iconiq Interior featured project Innocean Office Expansion"
              title="Featured Project | Innocean Office Expansion"
              loading="lazy"
            />
          </ProjectIMG>
          <ProjectIMG>
            <IMG
              src={images4}
              alt="Iconiq Interior featured project Innocean Office Expansion"
              title="Featured Project | Innocean Office Expansion"
              loading="lazy"
            />
          </ProjectIMG>
        </ProjectContainer>
      </AllProjectContainers>
    </>
  );
};

export default Innocean;
